import React, { useState, useEffect } from 'react'
import styled, { consolidateStreamedStyles } from 'styled-components'
import Modal from 'live/components/ui/Modal'
import LiveTooltip from 'live/components/ui/tooltip'

import '../main/options/modalFull.scss'


interface Props{
    options: string[]
    onChange: (value :string, index:number)=> void
    value: string
    placeholder: string
    index:number
    disabled?: boolean
}

export default function SelectOptions({ options, onChange, value, placeholder, index, disabled = false}:Props){

    return (
        <>
            { disabled? (
            <>
                <input
                    disabled={true}    
                    placeholder="Pick a date reference"
                />
            </>):(
                <StyledSelectOptions>
                    <select className={`select${disabled?'--disabled':''}`} disabled={disabled} value={value}  onChange={event=> onChange(event.target.value, index)} >
                        <option className="firstOption"  value="" disabled selected >
                                {placeholder}
                        </option>

                        {options.map(option =>(
                            <option>{option}</option>
                        ))}
                    </select>
                    <i class="fas fa-sort-down"></i>
                </StyledSelectOptions>)
            }
        </>
        
    )
}

const StyledSelectOptions = styled.div`
    .select{
        border: none;
        background: var(--gray-0);
        height: 35px;
        width:95%;
    }
    .firstOption{
        color:var(--gray-500);
        &--field{
            color:var(--gray-400);
        }
    }
    i{
        width:5%;
        color:var(--blue-500);
    }

`